<template>
  <div>
    <div
      class="bg-card text-left mb-2"
      no-body
    >
      <b-card-body class="p-1">
        <h1
          style="font-size: 1rem !important"
          class="p-2"
        >
          {{ $t('pages.admin.referrals.add-new-referral.title', 'Add new referral') }}
        </h1>
        <div class="p-3">
          <div class="d-flex">
            <div class="col-9">
              <b-input
                v-model="referral.title"
                size="sm"
                :placeholder="$t('pages.admin.referrals.add-new-referral.name.placeholder', 'Enter the description')"
                :state="$v.referral.title.$dirty ? !$v.referral.title.$invalid : null"
              />
              <div
                v-if="$v.referral.title.$error"
                class="text-danger"
              >
                {{ $t('pages.admin.referrals.add-new-referral.validation', { minLength: $v.referral.title.$params.minLength.min }) }}
              </div>
            </div>
            <div class="col-3">
              <b-button
                variant="success"
                size="sm"
                @click="createReferral"
              >
                <font-awesome-icon icon="plus" /> {{ $t('generic.add', 'Add') }}
              </b-button>
            </div>
          </div>
        </div>
      </b-card-body>
    </div>
    <div
      class="bg-card text-left"
      no-body
    >
      <b-card-body class="p-1">
        <h1
          style="font-size: 1rem !important"
          class="p-2"
        >
          {{ $t('pages.admin.referrals.list.title', 'Referrals') }}
        </h1>
        <div class="text-left mb-2">
          <span style="font-size: 0.8rem;">{{ $t('pages.admin.referrals.total-label', 'Total referral codes:') }}</span> {{ paginationMeta.total }}
        </div>
        <div
          id="filtersContainer"
          class="d-flex flex-row justify-content-between"
        >
          <b-input
            v-model="filter.fields.keyword"
            class="flex-grow-1 native"
            size="sm"
            :placeholder="$t('inputs.keyword.placeholder', 'Keywords')"
          />

          <b-form-select
            v-model="filter.order"
            size="sm"
            :options="orderByOptions"
          />

          <b-form-select
            v-model="filter.fields.filter"
            size="sm"
            :options="filterByOptions"
          />
        </div>
        <div class="p-3">
          <pagination
            v-if="paginationMeta"
            :data="paginationMeta"
            size="small"
            :limit="1"
            align="center"
            @pagination-change-page="getData"
          />
          <ReferralCard
            v-for="item in paginationMeta.data"
            :key="item.id"
            :referral="item"
            :status-click="toggleAction"
          />
          <pagination
            v-if="paginationMeta"
            :data="paginationMeta"
            size="small"
            :limit="1"
            align="center"
            @pagination-change-page="getData"
          />
        </div>
        <b-card-body
          v-if="paginationMeta && paginationMeta.data && paginationMeta.data.length === 0"
          class="p-5 text-center"
        >
          {{ $t('pages.admin.referrals.list.no-referrals', 'No referrals yet') }}
        </b-card-body>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { validationMixin } from 'vuelidate'
import ReferralCard from "@/components/jobs/admin/ReferralCard";

export default {
  components: {ReferralCard},
  mixins: [validationMixin],
  data() {
    return {
      filter: {
        fields: {
          keyword: '',
          filter: '',
        },
        order: '',
        watchersEnabled: false,
      },

      referral: {
        title: "",
        is_disabled: "",
      },

      page: 1,
      paginationMeta: {},
      debounces: {},
    }
  },

  computed: {
      orderByOptions() {
        return [
          {value: '', text: this.$t('pages.admin.referrals.filter-options.order.newest', 'Sort newest first' )},
          {value: 'update', text: this.$t('pages.admin.referrals.filter-options.order.last-updated', 'Sort by last update' )},
          {value: 'count', text: this.$t('pages.admin.referrals.filter-options.order.counter', 'Sort by count' )},
        ];
      },

      filterByOptions() {
        return [
          {value: '', text: this.$t('pages.admin.referrals.filter-options.filter.all', 'All referrals') },
          {value: 'active', text: this.$t('pages.admin.referrals.filter-options.filter.only-enabled', 'Only enabled') },
          {value: 'disabled', text: this.$t('pages.admin.referrals.filter-options.filter.only-disabled', 'Only disabled') },
        ];
      },
  },

  watch: {
    'filter.fields': {
      handler() {
        if (!this.filter.watchersEnabled) return;

        this.debounceCallback('filterUpdate', 750, () => {
            this.getData(1);
        });
      },

      deep: true,
    },

    'filter.order'() {
      if (!this.filter.watchersEnabled) return;

      this.debounceCallback('filterUpdate', 750, () => {
          this.getData(this.page);
      });
    },

    'referral.title'() {
      this.$v.$reset();
    },
  },

  mounted() {
    this.filter.fields = {
        keyword: this.$route.query.keyword,
        filter: this.$route.query.filter || '',
    };
    this.filter.order = this.$route.query.order || '';
    this.getData(this.$route.query.page || 1);
    setTimeout(() => {
      this.filter.watchersEnabled = true;
    }, 10);
  },

  methods: {
    createReferral() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$v.$reset();
      this.axios.post('/referral/create', this.referral)
        .then(() => {
          this.getData(this.page);
          this.resetForm();
          this.$toastNotification('success', '', this.$t('pages.admin.referrals.add-new-referral.success', 'Referral created'));
        })
        .catch( () => {
          this.$toastSomethingWentWrong();
        });
    },

    getData(page) {
      const config = { ...this.filter.fields, order: this.filter.order, page };
      this.$router.replace({ query: config });
      this.page = page;
      this.axios.get('/referral/all', { params: config })
        .then(response => {
          this.paginationMeta = response.data;
        })
        .catch(() => {
          this.$toastSomethingWentWrong();
        });
    },

    resetForm() {
      this.referral = {
        title: "",
        is_disabled: "",
      };
    },

    debounceCallback(key, duration, callback) {
      if (this.debounces[key]) {
        clearTimeout(this.debounces[key]);
      }

      this.debounces[key] = setTimeout(callback, duration);
    },

    toggleAction(item) {
      this.axios.post('/referral/edit', {
        id: item.id,
        is_disabled: !item.is_disabled,
      })
        .then(() => {
          item.is_disabled = !item.is_disabled;
          this.$toastNotification('success', '',
              item.is_disabled
                  ? this.$t('pages.admin.referrals.disable-success', 'Referral disabled')
                  : this.$t('pages.admin.referrals.enable-success', 'Referral enabled')
          );
        })
        .catch(() => {
          this.$toastSomethingWentWrong();
        });
    },
  },

  validations: {
    referral: {
      title: { required, minLength: minLength(4) },
    },
  },
}
</script>

<style lang="scss" scoped>
  .card {
    background: #f2f2f2;
  }
  #filtersContainer {
    * {
      margin: 5px;
    }

    button {
      min-width: 120px;
    }

    select {
      max-width: 200px;
    }
  }
</style>
